import React from 'react'
import classNames from 'classnames'

import { ImageItem } from './imageList'

interface IProps {
  list: ImageItem[]
  handleImageItemClick: (
    event: React.MouseEvent<HTMLImageElement, MouseEvent>
  ) => void
}

const ImageGrid = ({ list, handleImageItemClick }: IProps) => {
  return (
    <div className={classNames('image-list', `image-list-${list.length}`)}>
      {list.map(({ url }: any, index) => (
        <img
          key={index}
          src={url}
          data-index={index}
          onClick={handleImageItemClick}
        />
      ))}
      <style jsx>
        {`
          .image-list {
            display: grid;
            grid-template-columns: repeat(3, 247px);
            grid-template-rows: repeat(${Math.ceil(list.length / 3)}, 247px);
            grid-gap: 4px;
            margin-top: 20px;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            cursor: zoom-in;
          }
          .image-list-1 {
            display: block;
          }
          .image-list-1 img {
            height: 373px;
            object-fit: contain;
            background-color: black;
          }
          .image-list-2,
          .image-list-4 {
            grid-template-columns: repeat(2, 373px);
            grid-template-rows: repeat(${list.length / 2}, 373px);
          }
        `}
      </style>
    </div>
  )
}

export default ImageGrid
